import * as actionTypes from '../../action/projects/Projects'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_PROJECT_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_PROJECT_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                project: action.payload
            };
        
        case actionTypes.GET_PROJECT_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_PROJECT_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;